const rules = {
	RuleSet: "Rule Set",
	Name: "Name",
	Rule: "Rule"
};

export default rules;
